export default "__VITE_ASSET__D3Yut$YC__"